import { House, PiggyBank, SolarPanel } from 'svg';
import { Location } from 'types';
import { formatCurrencyWithSuffix, roundDown } from 'utils/number';
import Headline from './headline';

export interface Props {
  location: Location;
}

export default function Headlines({ location }: Props) {
  // const [isCalculatedTooltipOpen, setIsCalculatedTooltipOpen] = useState(false);
  const amountSettled = formatCurrencyWithSuffix(
    Number(location.amountSettled)
  );
  return (
    <div
      className="section mb-12 grid grid-rows-3 sm:grid-cols-3 sm:grid-rows-none gap-4"
      id="headlines"
    >
      <Headline
        ariaKey="upgrades"
        icon={<House />}
        value={Number(location.numSettled)}
        theme="primary"
        description="Upgrades installed to the scheme"
      />

      <Headline
        ariaKey="financed"
        icon={<PiggyBank />}
        value={amountSettled.amount}
        prefix="$"
        suffix={amountSettled.suffix}
        theme="secondary"
        description="Total amount financed to date"
      />

      <Headline
        ariaKey="energy"
        icon={<SolarPanel />}
        value={roundDown(Number(location.sumTotalPanelsCapacityKilowatt))}
        suffix="kW"
        theme="tertiary"
        description="Settled under the scheme in general"
      >
        {/* <a
          href="https://brighte.com.au/modal/definitions"
          target="_blank"
          rel="noreferrer"
          className="flexrow gap-2 items-center underline decoration-dotted underline-offset-4"
          aria-label="How do we calculate the annual GWh rate?"
          onMouseEnter={() => setIsCalculatedTooltipOpen(true)}
          onClick={() => setIsCalculatedTooltipOpen(!isCalculatedTooltipOpen)}
        >
          How is this calculated?
          <InformationCircle />
        </a>
        {isCalculatedTooltipOpen && (
          <div
            aria-roledescription="tooltip"
            className="tooltip absolute bg-gray-700 text-white p-4 mt-5 w-[300px]"
            onMouseEnter={() => setIsCalculatedTooltipOpen(true)}
            onMouseLeave={() => setIsCalculatedTooltipOpen(false)}
          >
            <p className="text-xs">
              The amount of energy that all solar installations funded by the
              Sustainable Household Scheme to date can generate in one year
              -&nbsp;
              <a
                href="https://brighte.com.au/modal/definitions"
                target="_blank"
                rel="noreferrer"
                className="underline underline-offset-4"
              >
                see calculations
              </a>
            </p>
          </div>
        )} */}
      </Headline>
    </div>
  );
}
